module.exports = __webpack_public_path__ + "media/images/certificate-view-c5662a994813eb17e7a5c00b28e0d893.jpg";